import { jsx, css } from '@emotion/react';

import Section from './oc-section';
import { connectLocation } from '../../location/LocationConnectors';
import RichText from '../oc-rich-text';

const styles = css`
  h3 {
    text-transform: uppercase;
    margin-top: 24px;
  }

  h4 {
    margin-top: 1em;
  }

  table {
    border-spacing: 0;
    margin-bottom: 2em;
    min-width: 500px;
    width: 100%;

    th,
    td {
      border-color: #bcbcbc;
      border-collapse: collapse;
      border-right: 1px solid #bcbcbc;

      padding: 10px 15px;

      &:last-of-type {
        border-right: none;
      }

      p {
        padding: 0;
        margin: 0;
      }
    }

    th {
      border-top: 2px solid #bcbcbc;
      border-bottom: 2px solid #bcbcbc;
      font-weight: bold;
      text-transform: uppercase;
      text-align: center;
    }

    td {
      text-align: center;
      border-bottom: 1px solid #bcbcbc;

      &:nth-of-type(1) {
        text-align: left;
      }
    }

    tr:nth-of-type(1n) {
      td {
        background-color: none;
      }
    }

    tr:nth-of-type(2n) {
      td {
        background-color: #f8f8f8;
      }
    }
  }
`;

const FormattedTable = connectLocation(({ t, contents, intro, heading, anchor, className }) => (
  <Section anchor={anchor} css={styles} className={className}>
    <h2>
      <RichText content={heading} />
    </h2>
    <div className="oc-table-responsive">
      {intro ? (
        <p>
          <RichText content={intro} />
        </p>
      ) : null}
    </div>
    <div className="oc-table-responsive">
      <RichText content={contents} />
    </div>
  </Section>
));

FormattedTable.WrappedComponent.displayName = 'FormattedTable';

export default FormattedTable;
